
import { supabase } from '@/integrations/supabase/client';

export const authService = {
  async signIn(email: string, password: string) {
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password
    });
    return { error };
  },

  async signUp(email: string, password: string, firstName?: string, lastName?: string, organizationName?: string, invitationId?: string) {
    const redirectUrl = `${window.location.origin}/auth`;
    
    const metadata: {
      first_name?: string;
      last_name?: string;
      organization_name?: string;
      invitation_id?: string;
    } = {
      first_name: firstName,
      last_name: lastName,
      organization_name: organizationName
    };

    // Include invitation_id in metadata if provided
    if (invitationId) {
      metadata.invitation_id = invitationId;
    }
    
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo: redirectUrl,
        data: metadata
      }
    });
    return { error };
  },

  async signOut() {
    await supabase.auth.signOut();
  },

  async resetPassword(email: string) {
    const redirectUrl = `${window.location.origin}/password-reset`;
    
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: redirectUrl
    });
    return { error };
  },

  async resendConfirmationEmail(email: string) {
    const redirectUrl = `${window.location.origin}/auth`;
    
    const { error } = await supabase.auth.resend({
      type: 'signup',
      email: email,
      options: {
        emailRedirectTo: redirectUrl
      }
    });
    return { error };
  }
};
